import { createTheme } from '@mui/material';

const riskColors = ['#40c000', '#8cca13', '#d8d526', '#ffb027', '#ff5814', '#ff0000'];
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#64b5f6',
      main: '#1976D2',
      dark: '#0d46a1',
      contrastText: '#fff'
    },
    secondary: {
      light: '#bc97e9',
      main: '#7619d2',
      dark: '#7b1fa2',
      contrastText: '#fff'
    },
    complementary: {
      light: '#e5ad54',
      main: '#d27619',
      dark: '#bf5213',
      contrastText: '#fff'
    },
    risks: riskColors,
    riskLevel: {
      low: riskColors[0],
      med: riskColors[3],
      medium: riskColors[3],
      high: riskColors[5],
      none: '#616161'
    }
  }
});
